<footer class="marketplace-footer">
    <div class="marketplace-footer__content">
        <div class="marketplace-footer__left">
            <div>
                <span class="marketplace-footer__brand">{{ title }}</span>
            </div>
            <div class="marketplace-footer__links">
                <a [href]="iubenda.termsAndConditions" target="_blank" rel="noreferrer">Termini e condizioni</a>
                <a [href]="iubenda.privacyPolicy" target="_blank" rel="noreferrer">
                    {{ 'pages.settings-page.privacyPolicyLabel' | transloco }}
                </a>
                <a [href]="iubenda.cookiePolicy" target="_blank" rel="noreferrer">
                    {{ 'pages.settings-page.cookiePolicyLabel' | transloco }}
                </a>
                <a *ngIf="showCookiePreferences && iubendaIsAvailable()" href="#" (click)="openIubendaPref($event)">
                    {{ 'pages.settings-page.cookiePolicyPreferencesLabel' | transloco }}
                </a>
            </div>
        </div>
        <div class="marketplace-footer__right">
            <div class="marketplace-footer__stores" *ngIf="showStoreBadges">
                <a [href]="storeUrl.apple" target="_blank" rel="noreferrer">
                    <img src="../../../../../assets/svg/download-on-the-app-store-apple-logo.svg" alt="Download on the App Store" class="marketplace-footer__store-badge">
                </a>
                <a [href]="storeUrl.googlePlay" target="_blank" rel="noreferrer">
                    <img src="../../../../../assets/svg/get-it-on-google-play-logo.svg" alt="Get it on Google Play" class="marketplace-footer__store-badge">
                </a>
            </div>
        </div>
    </div>
</footer>